import {
  TChatsBulkOperationsMoveToArchiveDesktopResponse,
  fetchChatsBulkOperationsMoveToArchiveDesktop,
} from '../../repositories/chats/v1/chats/bulk-operations/move-to-archive-desktop';
import { showAlert } from '../../slices/alertSlice';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { TThunkAction } from '../../types/redux/thunk';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';
import { deselectAllChats, toggleChatListPending } from '../chatList/actions';

const DEFAULT_ERROR_MESSAGE = 'Не удалось перенести чаты в архив';

/**
 * Перенести чаты в архив
 * @param {string[]} chatIds массив id чатов
 */
export const archiveChats =
  (chatIds: string[]): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    dispatch(toggleChatListPending(true));

    try {
      const { statusCode, response }: TChatsBulkOperationsMoveToArchiveDesktopResponse =
        await fetchChatsBulkOperationsMoveToArchiveDesktop({
          httpApi,
          parameters: {
            chatIds,
          },
          config: { requestConfig: { withCredentials: true } },
        });

      if (statusCode === 200) {
        dispatch(deselectAllChats());
      } else {
        throw getResponseError({
          domain: EExceptionDomain.Chat,
          response,
          defaultMessage: DEFAULT_ERROR_MESSAGE,
          statusCode,
        });
      }
    } catch (ex) {
      const exception = getGenericLikeError({
        error: ex,
        domain: EExceptionDomain.Chat,
        message: DEFAULT_ERROR_MESSAGE,
      });

      logger.error(exception, {
        microserviceName: 'chats',
        pathApi: '/v1/chats/bulk-operations/move-to-archive-desktop/',
        parameters: JSON.stringify({ chatIds }),
      });

      dispatch(showAlert({ message: DEFAULT_ERROR_MESSAGE }));
    } finally {
      dispatch(toggleChatListPending(false));
    }
  };
